import Link from 'next/link';
import { ExternalLink } from 'lucide-react';
import type { Author } from '@/content/blog/_types';

interface AuthorCardProps {
  author: Author;
  locale?: 'ru' | 'en';
}

export default function AuthorCard({ author, locale = 'ru' }: AuthorCardProps) {
  const name = locale === 'en' ? author.nameEn : author.nameRu;
  const role = locale === 'en' ? author.roleEn : author.roleRu;
  const initials = locale === 'en' ? 'SL' : 'СЛ';
  const bgColor = 'bg-keiro-green';

  return (
    <div className="flex items-center gap-4 py-6 border-y border-slate-200">
      {/* Initials Circle */}
      <div
        className={`${bgColor} text-white font-bold rounded-full w-14 h-14 flex items-center justify-center flex-shrink-0 text-lg`}
      >
        {initials}
      </div>

      {/* Author Info */}
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <p className="font-semibold text-slate-900">{name}</p>
          <Link
            href={author.linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-keiro-green hover:text-keiro-green-dark transition-colors"
            aria-label={`LinkedIn profile of ${name}`}
          >
            <ExternalLink size={16} />
          </Link>
        </div>
        <p className="text-sm text-slate-600">{role}</p>
      </div>
    </div>
  );
}
